import { render, staticRenderFns } from "./stadium_reduced_cost_form.vue?vue&type=template&id=6824f974&scoped=true&"
import script from "./stadium_reduced_cost_form.vue?vue&type=script&lang=ts&"
export * from "./stadium_reduced_cost_form.vue?vue&type=script&lang=ts&"
import style0 from "./stadium_reduced_cost_form.vue?vue&type=style&index=0&id=6824f974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6824f974",
  null
  
)

export default component.exports